<template>
    <div>
        <navigation-bar Close/>
        <div class="coupon main">
            <img :src="couponImage">

            <div class="container">
                <img v-if="isShowLogoOnList && logoImage !== ''" class="identify-logo" :src="logoImage">
                <div class="coupon-type" :title="typeName">{{typeName}}</div>
                <h4 class="mt-2">
                    {{commodityName}}
                    <span class="red">x{{count}}</span>
                </h4>
                <div class="UseBranch">
                    <h6>適用分店</h6>
                    <div class="branch-list" @click="gotoUsefulStoreList(couponId)">
                        <span v-for="(item, index) in storeList" :key="index">
                          {{item.name}}
                        </span>
                    </div>
                    <div class="arrow-btn" @click="gotoUsefulStoreList(couponId)"><i class="el-icon-arrow-right"></i></div>
                </div>

                <div class="UseBranch">
                    <h6>生效日期</h6>
                    <div class="date">
                        {{activationText}}
                    </div>
                </div>

                <div class="UseBranch">
                    <h6>兌換期限</h6>
                    <div class="date">
                        {{convertTimeText}}
                    </div>
                </div>
                <el-divider></el-divider>

                <h6>活動說明</h6>
                <p>{{content}}</p>
                <h6 class="mt-4">注意事項</h6>
                <p v-html="notice"></p>
            </div> <!--end of bottom_content-->

        </div>
        <div class="CartButton" v-if="ableUse&&!isUsed&&!disAbled" @click="addChoice()">
            <div class="button">
                <div class="text">
                    使用優惠
                </div>
            </div>
        </div>

        <CommDialog :value="isShowDialogWeb"
                    class="isWeb"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <UsefulStoreList isWeb :dataTokenWeb="dataToken2" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='UsefulStoreList'"/>
        </CommDialog>
    </div>
</template>

<script>
    import CommDialog from '@/components/CommDialog.vue';
    import UsefulStoreList from "@/views/store/UsefulStoreList";
    export default {
        name: "OrderCouponList",
        components: {
            CommDialog,
            UsefulStoreList,
        },
        data() {
            return {
                id: parseInt(this.$route.query.id ? this.$route.query.id : 0),
                couponId: parseInt(this.$route.query.couponId ? this.$route.query.couponId : 0),
                ableUse: this.$route.query.ableUse ? String(this.$route.query.ableUse) === "true" : false,
                isUsed: this.$route.query.isUsed ? String(this.$route.query.isUsed) === "true" : false,
                disAbled: this.$route.query.disAbled ? String(this.$route.query.disAbled) === "true" : false,
                choiceCode: this.$route.query.choiceCode ? this.$route.query.choiceCode : "",
                couponImage:'',
                commodityName:'',
                couponStart:'',
                convertEnd:'',
                content:'',
                notice:'',
                storeList: [],
                storeNameList:[],
                vendorList: [],
                merchantList: [],
                shoppingAreaList: [],
                count:0,
                typeName:'',
                logoImage: '',
                isShowLogoOnList: false,
                convertLimitType: 0,
                activationText: "",
                convertTimeText: "",

                isCordova: this.$public.isCordova(),
                dataToken2: '',
                isTypeWeb: '',
                isShowDialogWeb: false,
            }
        },
        created() {
            this.setupData();
        },
        mounted() {

        },
        methods: {
            setupData(){

                this.$http.fetchWithAuthEncrypt`GetMySelfCouponInfoById${{
                    'id': this.id,
                    'couponId': this.couponId,
                }} ${json => {

                    if (json.data !== null && json.data !== '') {
                        try {
                            json.data = this.$crypto.decryptObjectText(json.data)
                        } catch (e) {
                            //
                        }

                        this.id = json.data.id;
                        this.couponImage = json.data.imgUrl;
                        this.commodityName = json.data.name;

                        this.couponStart = json.data.couponStart;
                        this.convertEnd = json.data.convertEnd;
                        this.content = json.data.content;
                        this.notice = json.data.contentPrecautions;


                        this.storeNameList = json.data.storeNameList;
                        this.vendorList = json.data.vendorList;
                        this.merchantList = Object.values(json.data.merchantList).flat(2);
                        this.shoppingAreaList = Object.values(json.data.shoppingAreaList).flat(2);

                        this.count = json.data.count;

                        this.typeName = json.data.typeName;

                        this.logoImage = json.data.logoImage;
                        this.isShowLogoOnList = json.data.isShowLogoOnList;
                        this.convertLimitType = json.data.convertLimitType;
                        this.activationText = json.data.activationText;
                        this.convertTimeText = json.data.convertTimeText;

                        this.storeList = []
                        this.storeNameList.forEach( item => {
                            this.storeList.push({
                                "name": item.name === "" ? item.brandName : item.brandName + "-" + item.name,
                            })
                        })
                        this.merchantList.forEach( item => {
                            this.storeList.push({
                                "name": item.merchantName === "" ? item.brandName : (item.brandName === "" ? item.merchantName : item.brandName + "-" + item.merchantName),
                            })
                        })
                        this.vendorList.forEach( item => {
                            this.storeList.push({
                                "name": item.name,
                            })
                        })
                        this.shoppingAreaList.forEach( item => {
                            this.storeList.push({
                                "name": item.name,
                            })
                        })
                    }

                    // self.isLoading = false;
                }}`;
            },
            /** 到 適用店家列表 */
            gotoUsefulStoreList(id){
                if( this.isCordova){
                    this.$router.push({name: 'UsefulStoreList', query:{type: 'coupon', id: id}});
                }else {
                    this.dataToken2 = {type: 'coupon', id: id}
                    this.isTypeWeb = 'UsefulStoreList'
                    this.isShowDialogWeb = true
                }
            },
            addChoice(){
                let couponListSnapshotData = this.$store.state.pageSnapshot['OrderCouponList'];
                // 深拷貝，不然會污染其他頁面
                let temp = JSON.parse(JSON.stringify(couponListSnapshotData.couponChoiceList));
                if (this.choiceCode !== "") {
                    temp.push(this.choiceCode);
                }

                couponListSnapshotData.couponChoiceList = temp;
                this.$store.commit("savePageSnapshot",
                    {
                        routeName: 'OrderCouponList',
                        variable: couponListSnapshotData,
                    },
                );
                this.$router.go(-1);
            },
            onCommDialogClose() {
                this.isShowDialogWeb = false;
            },
        }
    }
</script>

<style lang="less" scoped src="../../less/order.less"/>
<style lang="less" scoped>
    /deep/.app-header{
        @media(min-width: 1024px){
            display: block!important;
        }
        .text-left{
            display: block !important;
        }
    }
</style>